export interface Config {
    /**
     * 是否自动定时检测页面需要曝光的元素,默认为[false]
     * @type {boolean}
     */
    observe: boolean;
    /**
     * 是否给上报元素触发上报成功事件,事件名为vtrackerEnd,默认为[false]
     * @type {boolean}
     */
    success: boolean;
    /**
     * 调试uin,会在上报url上自动带上该uin参数,默认为[]
     * @type {string}
     */
    debugUin: string;
    /**
     * Appid统一后缀,默认为空
     * @type {string}
     */
    appidSuffix: string;
    /**
     * localStorage自动跟踪trace信息最大有效时间,默认[5000ms]
     * @type {number}
     */
    traceExpired: number;
    /**
     * 是否开启sendBeacon
     * @type {boolean}
     */
    useBeacon: boolean;
    /**
     * URL上traceDetail为base64格式的时候的前缀
     * @type {string}
     */
    tracePrefix: string;
    /**
     * 是否开启页面停留时长上报,默认为[true]
     * @type {boolean}
     */
    stayReport: boolean;
    /**
     * 是否关闭自动检测DOM变更更新page列表
     * @type {boolean}
     */
    offAutoMutation: boolean;
    /**
     * 业务版本
     * @type {string}
     */
    busiVersion: string;
    /**
     * 指定上报url
     * @type {string}
     */
    reportUrl: string;
}

const buildConfig = (): Config => {
    const rootEl: Element = document.body;

    return {
        observe: rootEl.getAttribute("vt-observe") === "1",
        success: rootEl.getAttribute("vt-success") === "1",
        debugUin: rootEl.getAttribute("vt-debuguin") || "",
        appidSuffix: rootEl.getAttribute("vt-release") === "0" ? "_rc" : "",
        traceExpired: parseInt(rootEl.getAttribute("vt-expired"), 10) || 5000,
        useBeacon: rootEl.getAttribute("vt-beacon") === "1",
        tracePrefix: "base64-",
        stayReport: rootEl.getAttribute("vt-stayreport") !== "0",
        offAutoMutation: rootEl.getAttribute("vt-offautomutation") === "1",
        busiVersion: rootEl.getAttribute("vt-busiversion") || "",
        reportUrl: rootEl.getAttribute("vt-reporturl") || ""
    };
};

export const buildConfigFn = buildConfig;

export default buildConfig();
